import { Injectable } from '@angular/core';
import { PaginacaoDto } from '@core/dto/paginacao-dto';
import { AnexosEtapa2ResponseDTO } from '@core/dto/projeto-intervencao/anexos-etapa-2-response.dto';
import { ModeloDocumentacaoReadaptacaoDTO } from '@core/dto/projeto-intervencao/modelo-documentacao.dto';
import { URL_CONFIG } from '@core/utils/url-configs';
import { CreateDocumentosIntervencaoReadaptacaoDTO } from '@modules/readaptacao/common/interfaces/create-documentos-intervencao-readaptacao.dto';
import { ReadaptacaoResponseDTO } from '@modules/readaptacao/common/interfaces/dados-readaptacao-response.dto';
import { HistoricoReadaptacao } from '@modules/readaptacao/common/interfaces/historico-readaptacao-info.dto';
import { HistoricoReprovacao } from '@modules/readaptacao/common/interfaces/historico-reprovacao.dto';
import { ReadaptacaoAlteradaResponseDTO } from '@modules/readaptacao/common/interfaces/readaptacao-alterada-response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { DadosDocumentosReadaptacaoDTO } from '@modules/readaptacao/common/interfaces/dados-documentos-readaptacao.dto';

@Injectable({
  providedIn: 'root',
})
export class ReadaptacaoService {
  constructor(private readonly apiService: ApiService) {}

  public existeReadaptacaoVinculada(params: URLSearchParams): Observable<boolean> {
    const filters = params ? `?${params.toString()}` : '';
    return this.apiService
      .get(`${URL_CONFIG.url_readaptacao}/existe-readaptacao${filters}`)
      .pipe(map((res) => res.body.data));
  }

  public dadosReadaptacao(params: URLSearchParams): Observable<ReadaptacaoResponseDTO> {
    const filters = params ? `?${params.toString()}` : '';
    return this.apiService
      .get(`${URL_CONFIG.url_readaptacao}/dados-readaptacao${filters}`)
      .pipe(
        map((res) => new ReadaptacaoResponseDTO(res.body.data)),
      );
  }

  obterHistoricoReadaptacoes(obj: URLSearchParams) {
    const filtro = obj.toString() ? `?${obj.toString()}` : '';
    return this.apiService.get(`${URL_CONFIG.url_readaptacao}/historico-readaptacao${filtro}`)
    .pipe(map(response => {
      const historicoList = response.body.data?.data?.map(element => {
        return new HistoricoReadaptacao(element);
      });
      response.body.data.data = historicoList;
      return new PaginacaoDto<HistoricoReadaptacao>(response.body.data);
    }));
  }

  obterHistoricoReprovacoes(obj: URLSearchParams): Observable<PaginacaoDto<HistoricoReprovacao>> {
    const filtro = obj.toString() ? `?${obj.toString()}` : '';
    return this.apiService.get(`${URL_CONFIG.url_readaptacao}/historico-reprovacao${filtro}`)
      .pipe(map(response => {
        const historicoList = response.body.data?.data?.map(element => {
          return new HistoricoReprovacao(element);
        });
        response.body.data.data = historicoList;
        return new PaginacaoDto<HistoricoReprovacao>(response.body.data);
      }));
  }

  confirmarInformacoes(params: URLSearchParams) {
    const filtro = params ? `?${params.toString()}` : '';
    return this.apiService.post(`${URL_CONFIG.url_readaptacao}/confirma-informacoes${filtro}`, null);
  }

  getModelosDocumentacao(params: URLSearchParams) {
    const filtro = params ? `?${params.toString()}` : '';
    return this.apiService.get(`${URL_CONFIG.url_readaptacao}/ultimos-modelos-documento-pedagogico${filtro}`)
    .pipe(map(response => {
      return response.body.data?.map((element: any) => {
        return new ModeloDocumentacaoReadaptacaoDTO(element);
      });
    }));
  }

  getAnexosEtapa2(params: URLSearchParams) {
    const filtro = params ? `?${params.toString()}` : '';
    return this.apiService.get(`${URL_CONFIG.url_readaptacao}/etapa2-projeto-intervencao${filtro}`)
    .pipe(map(response => {
      return response.body.data?.map((element: any) => {
        return new AnexosEtapa2ResponseDTO(element);
      });
    }));
  }

  postAnexosReadaptacao(dto: CreateDocumentosIntervencaoReadaptacaoDTO) {
    return this.apiService.post(`${URL_CONFIG.url_readaptacao}/etapa2-documentos-readaptacao`, dto);
  }

  verificarReadaptacaoEditada(params: URLSearchParams): Observable<ReadaptacaoAlteradaResponseDTO> {
    const filters = params ? `?${params.toString()}` : '';
    return this.apiService
      .get(`${URL_CONFIG.url_readaptacao}/verificar-readaptacao-editada${filters}`)
      .pipe(map((res) => new ReadaptacaoAlteradaResponseDTO(res.body.data)));
  }

  usuarioVisualizouAlertaDadosAlterados(params: URLSearchParams) {
    const filters = params ? `?${params.toString()}` : '';
    return this.apiService
      .post(`${URL_CONFIG.url_readaptacao}/usuario-visualizou-alerta-dados-alterados${filters}`, null);
  }

  obterDadosCardsPeriodosReadaptacao(params: URLSearchParams): Observable<DadosDocumentosReadaptacaoDTO> {
    const filters = params ? `?${params.toString()}` : '';
    return this.apiService
      .get(`${URL_CONFIG.url_readaptacao}/obter-dados-cards-periodos${filters}`)
      .pipe(map((res) => new DadosDocumentosReadaptacaoDTO(res.body.data)));
  }
}
